import styled, { keyframes, css } from 'styled-components';

const fadeIn = keyframes`
	from { opacity: 0; }
	to { opacity: 1; }
`;

const fadeOut = keyframes`
	from { opacity: 1; }
	to { opacity: 0; }
`;

export const Overlay = styled.div`
	width: 100%;
	height: 100%;

	position: fixed;
	top: 0;
	left: 0;

	background: rgba(246, 245, 252, .7);

	display: flex;
	justify-content: center;
	align-items: center;

	animation: ${fadeIn} 0.3s;
	${({ isLeaving }) => isLeaving && css`animation: ${fadeOut} 0.2s;`}
`;
